import { render, staticRenderFns } from "./UnitCreate.vue?vue&type=template&id=74ccec0d&scoped=true"
import script from "./UnitCreate.vue?vue&type=script&lang=js"
export * from "./UnitCreate.vue?vue&type=script&lang=js"
import style0 from "./UnitCreate.vue?vue&type=style&index=0&id=74ccec0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ccec0d",
  null
  
)

export default component.exports